import { SharedModule } from 'src/app/shared/shared.module'

import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'

import { AppShellLayoutComponent } from './app-shell/app-shell-layout.component'
import { BrandedPageLayoutComponent } from './branded-page/branded-page-layout.component'
import { CartBlockComponent } from './cart-block/show.component'
import { FooterComponent } from './footer/show.component'
import { PrimaryNavbarComponent } from './primary-navbar/show.component'
import { RoleModule } from '../features/role/role.module'
import { PrimaryNavbarPendingSaleBlockComponent } from './primary-navbar/primary-navbar-pending-sale-block/show.component'
import { PrimaryNavBarTopMenuComponent } from './primary-navbar/primary-navbar-top-menu-block/show.component'
import { PrimaryNavBarDesktopMainMenuComponent } from './primary-navbar/primary-navbar-desktop-main-menu-block/show.component'
import { PrimaryNavBarMobileMainMenuComponent } from './primary-navbar/primary-navbar-mobile-main-menu-block/show.component'
import { PrimaryNavbarNonLoggedInComponent } from './primary-navbar/primary-navbar-non-logged-in/show.component'

@NgModule({
  imports: [CommonModule, RouterModule, SharedModule, RoleModule],
  providers: [],
  declarations: [
    PrimaryNavBarDesktopMainMenuComponent,
    PrimaryNavBarMobileMainMenuComponent,
    PrimaryNavBarTopMenuComponent,
    PrimaryNavbarPendingSaleBlockComponent,
    AppShellLayoutComponent,
    BrandedPageLayoutComponent,
    PrimaryNavbarComponent,
    CartBlockComponent,
    FooterComponent,
    PrimaryNavbarNonLoggedInComponent
  ],
  exports: [
    BrandedPageLayoutComponent,
    AppShellLayoutComponent,
    PrimaryNavbarComponent,
    FooterComponent,
    PrimaryNavbarNonLoggedInComponent
  ]
})
export class LayoutModule {}
